import constant from '../../constant';
import request from '../../../utils/request';
import { GET_RECOMMAND_VIDEOS, GET_TRPC_RECOMMAND_VIDEOS } from '../../../urls'
import { getAppName, showTip } from '../../../utils'
import { getUserKey } from '../../../utils/yUtil'
import { isTBS, isAndroid } from "../../../utils/UA";
import { APP_INFO } from "../../../utils/constant";
import TBSDownload from "../../../utils/tbs-download";
import { parseUrl } from "../../../utils/url";


const userKey = getUserKey()

const getVideoRecommend = (params = {}, callback) => {
  return async (dispatch) => {
    try {
      const { sDocId, url, guid, classify } = params
      if (sDocId) {
        const res = await request.get(GET_RECOMMAND_VIDEOS, {
          docId: sDocId,
          url: decodeURIComponent(url),
          guid: guid || userKey,
          classify
        })

        if (res.code === 0) {
          dispatch(getRecommendSuccess(res.data))
          const { cardContents = [], endCard = {}, banner = {} } = res.data
          let docIdArr = []
          cardContents.forEach((cardContent) => {
            cardContent.videos.forEach((video) => {
              docIdArr.push(video.cid)
            });
          });

          endCard.videos && endCard.videos.forEach((video) => {
            docIdArr.push(video.cid)
          });
          banner.videos && banner.videos.forEach((video) => {
            docIdArr.push(video.cid)
          });
          callback && callback(docIdArr || [])
        } else {
          showTip('视频跑丢了')
        }
      } else {
        showTip('缺少必要参数 docId')
      }

    } catch (error) {
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}
const getTRPCRecommand = (params = {}, callback) => {
  return async (dispatch) => {
    try {
      const { sDocId, url, guid, classify } = params
      if (sDocId) {
        const res = await request.get(GET_TRPC_RECOMMAND_VIDEOS, {
          docId: sDocId,
          url: decodeURIComponent(url),
          guid: guid || userKey,
          classify
        })

        if (res.code === 0) {
          dispatch(getRecommendSuccess(res.data))
          callback && callback([]);

          if (getAppName() === 'qb') {
            // 获取剪贴板
            const { cardContents = [], banner = {} } = res.data
            let docIdArr = [];
            const transformVideo = (video) => {
              let videoUrl = '';
              if (video.contentUrl) {
                const urlObj = parseUrl(video.contentUrl);
                videoUrl = decodeURIComponent((urlObj.query && urlObj.query.videoUrl) || '');
              }
              return { docId: video.cid, videoUrl, imageUrl: video.imageUrl || '', title: video.title || '' }
            }
            cardContents.forEach((cardContent) => {
              cardContent.videos.forEach((video) => {
                docIdArr.push(transformVideo(video))
              })
            });
            banner.videos && banner.videos.forEach((video) => {
              docIdArr.push(transformVideo(video))
            });
            const appInfo = APP_INFO['qb'];
            const tbsDownload = new TBSDownload(window.tbs, appInfo.downloadUrl, appInfo.pkgName, '');
            window.ClipperForRMP && window.ClipperForRMP.initRmpNew({
              event: 3,
              type: 1,
              data: docIdArr,
              qbinstall: (isAndroid(window.navigator.userAgent) && isTBS(window.navigator.userAgent) && tbsDownload.isInstalled()) ? 1 : 0,
              env: window.location.host.indexOf('.sparta.html5.qq.com') > -1 ? 'test' : (window.location.host.indexOf('graykandianshare.html5.qq.com') > -1 ? 'gray' : 'pro') // 测试环境调用rmp的测试接口
            })
          }
        } else {
          showTip('视频跑丢了')
        }
      } else {
        showTip('缺少必要参数 docId')
      }

    } catch (error) {
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}


const getRecommendSuccess = (cardContents) => {
  return {
    type: constant.VIDEO.GET_RECOMMEND_VIDEO,
    ...cardContents
  }
}


export default {
  getRecommendSuccess,
  getVideoRecommend,
  getTRPCRecommand
}
